module.exports = __webpack_public_path__ + "static/media/poweredby-darksky.6a802cb1.png";